module.exports = __webpack_public_path__ + "static/img/2noise_gate.d375544.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls37-1/2noise_gate.png
// module id = 1xg5
// module chunks = 12